import useJwt from '@core/auth/jwt/useJwt'
import axiosConsole from '@utils/axios'
import axiosIdentity from '@utils/axiosIdentity'
import axiosNotificator from '@/utils/axiosNotificator'

const { jwt } = useJwt(axiosConsole, {})
export const { jwtIdentity } = useJwt(axiosIdentity, {})
export const { jwtNotificator } = useJwt(axiosNotificator, {})
export default jwt
